import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Button, ButtonGroup, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useProfileAuthStore } from "../store/ProfileStore";
import { getChannelViewBaseURL } from "../ContentAPI";
export function TopButtonMenu(props) {
    const navigate = useNavigate();
    const auth = useProfileAuthStore((state) => state);
    const buttonStyle = { paddingLeft: "8px", paddingRight: "8px" };
    const buttons = (_jsx(Stack, Object.assign({ direction: "row", sx: {
            width: "auto",
            display: "flex",
            justifyContent: "center",
            margin: "3px",
            marginBottom: "0",
        } }, { children: _jsxs(ButtonGroup, Object.assign({ size: "small", variant: "outlined", "aria-label": "Basic button group" }, { children: [_jsx(Button, Object.assign({ variant: props.current === "latest" ? "contained" : "outlined", sx: buttonStyle, onClick: () => {
                        // If user is not authenticated, stay on public page (which shows latest content)
                        if (auth && auth.isSignedIn()) {
                            navigate("/Latest");
                        }
                        else {
                            // For unauthenticated users, navigate to root (public page) which shows latest content
                            navigate("/");
                        }
                    } }, { children: "Latest" })), _jsx(Button, Object.assign({ variant: props.current === "feed" ? "contained" : "outlined", sx: buttonStyle, onClick: () => {
                        const displayName = auth === null || auth === void 0 ? void 0 : auth.displayName;
                        if (displayName) {
                            // Use the complete URL with proper localhost/production handling
                            const feedUrl = getChannelViewBaseURL() + displayName;
                            window.location.href = feedUrl;
                        }
                        else {
                            navigate("/Feed"); // Fallback to redirect component
                        }
                    } }, { children: "Feed" })), _jsx(Button, Object.assign({ variant: props.current === "channels" ? "contained" : "outlined", sx: buttonStyle, onClick: () => {
                        navigate("/Channels");
                    } }, { children: "Channels" })), _jsx(Button, Object.assign({ variant: props.current === "friends" ? "contained" : "outlined", sx: buttonStyle, onClick: () => {
                        navigate("/Friends");
                    } }, { children: "Friends" })), _jsx(Button, Object.assign({ variant: props.current === "studio" ? "contained" : "outlined", sx: buttonStyle, onClick: () => {
                        navigate("/Studio");
                    } }, { children: "Studio" }))] })) })));
    return buttons;
}
